import loadable from '@loadable/component'

export const getBillPaymentComponentByVersion = (versionParam: string) => {
  switch (versionParam) {
    case 'v1':
      return loadable(() =>
        import(/* webpackChunkName: "bill-payment" */ '@/components/bill-payment'),
      )
    case 'v2':
      return loadable(() =>
        import(/* webpackChunkName: "bill-payment-v2" */ '@/components/version/V2/bill-payment'),
      )
    case 'v3':
      return loadable(() =>
        import(/* webpackChunkName: "bill-payment-v3" */ '@/components/version/V3/bill-payment'),
      )
    default:
      loadable(() => import(/* webpackChunkName: "bill-payment" */ '@/components/bill-payment'))
  }
}

export const getSchedulePaymentComponentByVersion = (versionParam: string) => {
  switch (versionParam) {
    case 'v1':
      return loadable(() =>
        import(/* webpackChunkName: "schedule-payment" */ '@/components/schedule-payment'),
      )
    case 'v2':
      return loadable(() =>
        import(/* webpackChunkName: "schedule-payment-v2" */ '@/components/version/V2/schedule-payment'),
      )
    default:
      loadable(() => import(/* webpackChunkName: "schedule-payment" */ '@/components/schedule-payment'))
  }
}
